import { FunctionComponent, ReactElement } from "react";
import Select, { MultiValue, MultiValueProps, OptionProps, components } from "react-select";

// Types
import { CustomColumnFilterOption } from "../../../utils/types";

const { Option, MultiValue: MultiValueComponent } = components;

interface ColumnFilterMultiSelectProps {
	isDisabled: boolean | undefined;
	options: Array<CustomColumnFilterOption>;
	existingValues: string | number;
	onChangeHandler: (newValues: MultiValue<CustomColumnFilterOption>) => void;
}

const ColumnFilterMultiSelect: FunctionComponent<ColumnFilterMultiSelectProps> = (
	props: ColumnFilterMultiSelectProps
): ReactElement => {
	const { isDisabled, options, existingValues, onChangeHandler } = props;

	const getSelectOption = (optionProps: OptionProps<CustomColumnFilterOption>) => {
		return (
			<Option {...optionProps} key={`lampselect-${optionProps.data.value}`}>
				{optionProps.data.icon && optionProps.data.icon}
				{optionProps.data.label}
			</Option>
		);
	};

	const getMultiValueOption = (valueProps: MultiValueProps<CustomColumnFilterOption>) => {
		return <MultiValueComponent {...valueProps}>{valueProps.data.icon && valueProps.data.icon}</MultiValueComponent>;
	};

	const onChangeInternalHandler = (newValues: MultiValue<CustomColumnFilterOption>): void => {
		onChangeHandler(newValues);
	};

	const getSelectedValues = (): Array<CustomColumnFilterOption> => {
		if (existingValues) {
			return options.filter(
				(option: CustomColumnFilterOption) => existingValues.toString().split(",").indexOf(option.value.toString()) > -1
			);
		} else return [];
	};

	return (
		<Select
			options={options}
			value={getSelectedValues()}
			components={{ Option: getSelectOption, MultiValue: getMultiValueOption }}
			menuPortalTarget={document.body}
			isMulti={true}
			placeholder={""}
			onChange={(newValues: MultiValue<CustomColumnFilterOption>) => onChangeInternalHandler(newValues)}
			isDisabled={isDisabled}
			styles={{
				menuPortal: (base) => ({ ...base, zIndex: 9999 }),
				option: (base) => ({ ...base, display: "flex", padding: "5px 10px" }),
				menuList: (base) => ({ ...base, width: "max-content", fontSize: "0.9rem" }),
				menu: (base) => ({ ...base, width: "auto" }),
				valueContainer: (base) => ({ ...base, minWidth: "32px" }),
				multiValueLabel: (base) => ({ ...base, textOverflow: "unset" }),
				control: (base) => ({
					...base,
					minWidth: existingValues ? "142px" : "80px",
					minHeight: "32px",
					borderColor: "gray.300"
				}),
				dropdownIndicator: (base) => ({ ...base, padding: "5px 8px" }),
				clearIndicator: (base) => ({ ...base, padding: "5px 0px 5px 8px" }),
				indicatorSeparator: (base) => ({ ...base, display: "none" })
			}}
		/>
	);
};

export default ColumnFilterMultiSelect;
